export default __webpack_public_path__ + "static/media/under_construction.e82ffb3f.jpg";